import useCurrentProduct from "@/services/product/hooks/use-current-product.ts";

export default function useCurrentBeamAngle() {
    const product = useCurrentProduct();

    return product?.properties.beam_angle ?? null;
}
